import createPalette from './createPalette';

export const colors = {
  black: createPalette('#444444'),
  blue: createPalette('#5FBFF9'),
  green: createPalette('#23F0C7'),
  grey: createPalette('#888888'),
  orange: createPalette('#F5A623'),
  purple: createPalette('#70296a'),
  red: createPalette('#F11A3E'),
  teal: createPalette('#16F1EA'),
  white: createPalette('#F8F8F8'),
  yellow: createPalette('#FFDB5B'),
};

export const palettes = {
  default: colors.grey,
  primary: colors.purple,
  secondary: colors.blue,
  accent: colors.orange,
  info: colors.teal,
  success: colors.green,
  danger: colors.red,
  warning: colors.yellow,

  text: colors.black,
  background: colors.white,
  buttonText: colors.white,
};

export const palette = {
  ...palettes,
  ...colors,
};

export default palette;

export const paletteTypes = Object.keys(palette);



// WEBPACK FOOTER //
// ./src/styles/palette.js